<template>
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.5 5.13v1.75c0 .83-.67 1.5-1.5 1.5H4c-.83 0-1.5-.67-1.5-1.5V5.13c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5zM1 4.25v-2h2c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H.5c-.28 0-.5.22-.5.5v2.5c0 .28.22.5.5.5s.5-.22.5-.5zm2.5 6c0-.28-.22-.5-.5-.5H1v-2c0-.28-.22-.5-.5-.5s-.5.22-.5.5v2.5c0 .28.22.5.5.5H3c.28 0 .5-.22.5-.5zm8.5-6v-2.5c0-.28-.22-.5-.5-.5H9c-.28 0-.5.22-.5.5s.22.5.5.5h2v2c0 .28.22.5.5.5s.5-.22.5-.5zm0 6v-2.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5v2H9c-.28 0-.5.22-.5.5s.22.5.5.5h2.5c.28 0 .5-.22.5-.5z"
        />
    </svg>
</template>
